/**
 * Transforms a value for display into a fixed precision of
 * 3 significant figures, for values from 0 up to 1 trillion.
 *
 * @param {number|string} value
 * @return {string|*}
 */
export default function readableStat(value) {
  if (!value || typeof value === 'string' && !value.match(/^\d+$/)) {
    return value;
  }
  const number = parseInt(value, 10);
  if (number === 0) {
    return '-';
  }
  if (number < 10 ** 3) {
    return value;
  }
  if (number < 10 ** 6) {
    return `${(number / 10 ** 3).toPrecision(3)}K`;
  }
  if (number < 10 ** 9) {
    return `${(number / 10 ** 6).toPrecision(3)}M`;
  }
  // If any client gets this far...I'd love to meet them
  // (and they probably have a bigger monitor anyway - great problem to have!)
  return `${(number / 10 ** 9).toPrecision(3)}B`;
}